import { PRELOAD } from '../constants/MethodNames';
import { callingAPIMethodWithQueue } from '../utils/hsCallingUtils';
export default function preloadCallingWidget() {
  return callingAPIMethodWithQueue(PRELOAD);
}